import { ISection } from '@creditflowresearch/uilib/Section';

type ExpandStrategy =
  | { type: 'all' }
  | { type: 'none' }
  | { type: 'first', count?: number };

const resolveExpandedKeys = (sections: ISection[], strategy: ExpandStrategy): string[] => {
  if (strategy.type === 'all') {
    return sections.map((s) => s.id);
  }

  if (strategy.type === 'first') {
    return sections.slice(0, strategy.count ?? 1).map((s) => s.id);
  }

  return [];
};

export { resolveExpandedKeys };
export type { ExpandStrategy };
